/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:ef4d39ba-d111-42c7-884a-49c593572c4c",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_SttinRcx1",
    "aws_user_pools_web_client_id": "2l1da4dvs38a586dgco2r7c3g2",
    "oauth": {
        "domain": "keygleedispo-ecommerce-dev.auth.us-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://localhost:3000/dashboard/",
        "redirectSignOut": "https://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "photos141128-dev",
    "aws_user_files_s3_bucket_region": "us-west-1",
    "aws_dynamodb_all_tables_region": "us-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "properties-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "dispo-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "employees-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "events-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "careers-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "applications-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "payouts-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "dispoemployees-dev",
            "region": "us-west-1"
        },
        {
            "tableName": "inventory-dev",
            "region": "us-west-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "valproperties",
            "endpoint": "https://cumgm47d8l.execute-api.us-west-1.amazonaws.com/dev",
            "region": "us-west-1"
        }
    ],
    "aws_content_delivery_bucket": "valorant-host-dev",
    "aws_content_delivery_bucket_region": "us-west-1",
    "aws_content_delivery_url": "https://d2mubl49cwf58e.cloudfront.net"
};


export default awsmobile;
